import { FC } from "react"
import { SubscriptionDetails } from "../../../../../../../types"
import SectionCell from "../../../../../section/cell"
import { CurrencyValueCell } from "../../../../../section/items"

interface Props {
  data: SubscriptionDetails
}

const LoFields: FC<Props> = ({ data }) => {
  const {
    quote_info: { admin_fields, list_price }
  } = data
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      <SectionCell
        label="Annual taxes"
        value={
          admin_fields?.taxes > 0
            ? `${admin_fields.taxes}% | ${(
                (admin_fields.taxes / 100) *
                list_price
              ).toFixed(2)}`
            : null
        }
        className="!pt-0"
      />
      <SectionCell
        label="Annual home insurance"
        value={
          admin_fields?.insurance > 0
            ? `${admin_fields.insurance}% | ${(
                (admin_fields.insurance / 100) *
                list_price
              ).toFixed(2)}`
            : null
        }
        className="!pt-0"
      />
      {admin_fields?.custom_fee_amount != null &&
        admin_fields.custom_fee_amount > 0 && (
          <CurrencyValueCell
            label={admin_fields.custom_fee_label || "Custom Fee"}
            value={admin_fields.custom_fee_amount}
          />
        )}
    </div>
  )
}

export default LoFields
